module.exports = __webpack_public_path__ + "assets/img/tx102n_1.7807cc06.jpg";